var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{class:[!_vm.footer ? 'hide' : '', _vm.navFooterScheme],attrs:{"fixed":_vm.fixedFooter,"inset":!_vm.fixedFooter,"app":""}},[_c('div',{staticClass:"pa-3"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Kronos Educacional. Todos os direitos reservados. Versão - "+_vm._s(_vm.versao))]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }